import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SETTINGS_SERVICE } from '../../../common/constants/injection-tokens';
import { SettingsModel } from '../../../common/models/settings.model';
import { BaseSettingsGetService } from '../../../common/services/base-settings.service';
import { FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';

@Component({
    selector: 'lib-learning-path-card',
    templateUrl: './learning-path-card.component.html',
    styleUrls: ['./learning-path-card.component.scss'],
    standalone: false
})
export class LearningPathCardComponent implements OnInit {

  @Input() item: any;
  @Input() startButtonLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() set settingsForm(data: FormGroup) {
    if (!data) {
      return;
    }
    
    data.valueChanges.pipe(
      startWith(data.value)
    ).subscribe(settings => {
      this._settings = data.value;
      this.setSettings(settings);
    })
  }
  public get settings(): SettingsModel {
    return this._settings;
  }

  @Output() onStart: EventEmitter<any> = new EventEmitter();

  public cardsSettings: any;

  public leaderboardEnabled = false;
  public certificatesEnabled = false;
  public achievementsEnabled = false;

  private _settings: SettingsModel;

  constructor(
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
  ) { }

  ngOnInit(): void {
    if (!this.settings) {
      this.settingsService.getSettings().subscribe(settings => {
        this.setSettings(settings);
      })
    }
  }

  public start(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.onStart.emit();
  }

  private setSettings(settings: SettingsModel): void {
    this.cardsSettings = settings.layout.cards;
    this.leaderboardEnabled = settings.features?.leaderboard;
    this.achievementsEnabled = settings.features?.achievements;
    this.certificatesEnabled = settings.features?.certificates;
  }

}
